<p-toast></p-toast>

<form
        [formGroup]="contactForm"
        (ngSubmit)="onSubmit()"
        [ngClass]="{ 'was-validated': submitted }"
        novalidate
        class="form-container">
    <div class="form-grid">

        <div class="row gap-4 gap-sm-0">
            <div class="col-sm-6">
                <!-- First Name -->
                <div class="form-group">
                    <label>First Name</label>
                    <input class="form-control" formControlName="firstName" placeholder="Jason" />
                    <div class="invalid-feedback" *ngIf="(contactForm.get('firstName')?.touched || submitted) && contactForm.get('firstName')?.invalid">
                        First name is required.
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <!-- Last Name -->
                <div class="form-group">
                    <label>Last Name</label>
                    <input class="form-control" formControlName="lastName" placeholder="Blair" />
                    <div class="invalid-feedback" *ngIf="(contactForm.get('lastName')?.touched || submitted) && contactForm.get('lastName')?.invalid">
                        Last name is required.
                    </div>
                </div>
            </div>
        </div>

        <div class="row gap-4 gap-sm-0">
            <div class="col-sm-6">
                <!-- Email -->
                <div class="form-group">
                    <label>Email</label>
                    <input class="form-control" formControlName="email" type="email" placeholder="youremail@example.com" />
                    <div class="invalid-feedback" *ngIf="(contactForm.get('email')?.touched || submitted) && contactForm.get('email')?.invalid">
                        <span *ngIf="contactForm.get('email')?.errors?.['required']">Email is required.</span>
                        <span *ngIf="contactForm.get('email')?.errors?.['email']">Enter a valid email.</span>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <!-- Phone -->
                <div class="form-group">
                    <label>Phone number</label>
                    <input class="form-control" formControlName="phone" placeholder="XXXXXXX" />
                    <div class="invalid-feedback" *ngIf="(contactForm.get('phone')?.touched || submitted) && contactForm.get('phone')?.invalid">
                        <span *ngIf="contactForm.get('phone')?.errors?.['required']">Phone number is required.</span>
                        <span *ngIf="contactForm.get('phone')?.errors?.['pattern']">Enter a valid Phone number.</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <!-- Company Name -->
                <div class="form-group full-width">
                    <label>Company name</label>
                    <input formControlName="company" />
                </div>
            </div>
            <div class="col-sm-6"></div>
        </div>


        <!-- Partnership Type -->
        <div class="form-group full-width">
            <label>What type of partnership are you looking for?</label>
            <select formControlName="partnership">
                <option value="">Select an option</option>
                <option>Stock and Reseller NutriGenic Meals</option>
                <option>Corporate Catering</option>
                <option>Employee Meal Plans</option>
            </select>
            <div class="invalid-feedback" *ngIf="(contactForm.get('partnership')?.touched || submitted)&& contactForm.get('partnership')?.invalid">
                Please select a partnership type.
            </div>
        </div>

        <!-- Message -->
        <div class="form-group full-width">
            <label>Leave us a message</label>
            <textarea formControlName="message" placeholder="Add any other information we should know"></textarea>
        </div>
    </div>

    <div class="recaptcha-wrapper">
        <re-captcha
                #captchaRef="reCaptcha"
                formControlName="recaptcha"
                [siteKey]="recaptchaKey"
                size="invisible"
                (resolved)="onCaptchaResolved($event)"
        ></re-captcha>
        <div class="invalid-feedback" *ngIf="submitted && contactForm.get('recaptcha')?.invalid">
            Please verify you are not a robot.
        </div>
    </div>

    <div class="text-center">
        <button type="submit" class="submit-btn">Send</button>
    </div>
</form>
